export default {
    INTRODUCE_CAFE_LOADING: 'INTRODUCE_CAFE_LOADING',
    INTRODUCE_CAFE_SUCCESS: 'INTRODUCE_CAFE_SUCCESS',
    INTRODUCE_CAFE_FAILED: 'INTRODUCE_CAFE_FAILED',
    INTRODUCE_CAFE_REJECT: 'INTRODUCE_CAFE_REJECT',
  };